import React, { useCallback } from "react";
import { Building2 } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { StateBadge } from "./AdminLayout";
import { apiGet, apiPost, apiPut } from "./adminApi";

const fields = [
  { name: "institutionCode", label: "Institution Code", type: "text", placeholder: "e.g. UR" },
  { name: "fullName", label: "Institution Name", type: "text", required: true, placeholder: "e.g. University of Rwanda" },
  { name: "fullAdress", label: "Address", type: "textarea", placeholder: "Physical address" },
  { name: "active", label: "Status", type: "checkbox", checkboxLabel: "Institution is active", editOnly: true, fullWidth: true },
];

export default function InstitutionsPage() {
  const toFormValues = useCallback((row) => ({ ...row, active: row.state === 1 }), []);
  return (
    <AdminCrudPage
      title="Higher Learning Institutions"
      subtitle="Universities and institutions whose students apply for bursaries and loans"
      icon={Building2}
      entityName="institution"
      queryKey="adminInstitutions"
      fetchAll={() => apiGet("hec/hli/getAllHli")}
      createItem={({ active, ...values }) => apiPost("hec/hli/admin/create", values)}
      updateItem={(id, { active, ...values }, row) =>
        apiPut(`hec/hli/${id}`, { ...values, state: active ? 1 : 0, version: row.version })
      }
      searchKeys={["institutionCode", "fullName", "fullAdress"]}
      columns={[
        { key: "institutionCode", label: "Code", render: (r) => <span className="font-mono text-gray-700">{r.institutionCode || "—"}</span> },
        { key: "fullName", label: "Institution", render: (r) => <span className="font-semibold text-gray-900">{r.fullName}</span> },
        { key: "fullAdress", label: "Address", cellClassName: "max-w-md truncate" },
        { key: "state", label: "Status", render: (r) => <StateBadge state={r.state} /> },
      ]}
      fields={fields}
      toFormValues={toFormValues}
      emptyHint="Register the institutions before adding their colleges and campuses."
    />
  );
}
